<template>
  <div>
    <div class="d-flex align-items-center mb-4">
      <span class="tab-title">
        {{ $l('INDEX.tab_pane_title_awsSkuProductSpec') || '产品规格' }}
      </span>

      <el-divider v-if="addAllowed" direction="vertical" class="mx-3" />

      <b-button
        v-if="addAllowed"
        size="sm"
        variant="outline-success"
        @click="editOpts.visible = true"
      >
        {{ $l('INDEX.btn_addAwsSkuProductSpec') || '新增规格' }}
      </b-button>
    </div>

    <AwsSkuProductSpecItems
      :list="list"
      :buttons="buttons"
      :isSingle="isSingle"
      :sku="sku"
      @reload="reload"
    />

    <AwsSkuProductSpecEdit
      :visible.sync="editOpts.visible"
      :amzSkuCode="amzSkuCode"
      :editImage="!isSingle"
      :isSingle="isSingle"
      :sku="sku"
      @reload="reload"
    />
  </div>
</template>

<script>
import AwsSkuProductSpecItems from '../aws-sku-product-spec-items'
import AwsSkuProductSpecEdit from '../aws-sku-product-spec-edit'
export default {
  components: { AwsSkuProductSpecItems, AwsSkuProductSpecEdit },
  props: {
    amzSkuCode: { type: String, default: '' },
    disabled: { type: Boolean, default: true },
    isFormal: { type: Boolean, default: false },
    isSingle: { type: Boolean, default: true },
    sku: { type: Object, default: () => ({}) },
  },
  data() {
    return { editOpts: { visible: false }, list: [] }
  },
  computed: {
    addAllowed() {
      if (this.disabled) return false
      if (this.isFormal) return false
      if (!this.isSingle) return true
      return this.list.length < 1
    },
    buttons() {
      if (this.disabled) return []
      if (this.isFormal) return this.isSingle ? [] : ['editImage']
      if (this.isSingle) return ['edit', 'remove']
      return ['edit', 'remove', 'editImage']
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      if (!this.amzSkuCode) return

      const res = await this.$api
        .ecomAmzSkuSpecListApi({ amzSkuCode: this.amzSkuCode })
        .catch(() => null)
      if (!res) return

      this.list = res.body?.data || []
    },
    reload() {
      this.getData()
      this.$emit('reload')
    },
  },
}
</script>

<style lang="scss" scoped>
.tab-title {
  font-size: 16px;
  font-weight: bold;
  color: #2b3447;
}
</style>
